<chapps-tab-group [title]="Localization.Messages | translate">
  <!--  Latest messages -->
  <chapps-tab [label]="Localization.Latest | translate"
              (activated)="showLatestMessages()">
    <ng-container *ngTemplateOutlet="LegacyMessageView"></ng-container>
  </chapps-tab>

  <!--  Unread messages -->
  <chapps-tab [label]="Localization.Unread | translate"
              (activated)="showUnreadMessages()">
    <ng-container *ngTemplateOutlet="LegacyMessageView"></ng-container>
  </chapps-tab>

  <section tab-header-postfix>
    <chapps-primary-button [small]="true"
                           [icon]="'fa-eye'"
                           [label]="Localization.SeeMore | translate"
                           [outline]="true"
                           (clicked)="goToNotificationDetailsPage()">
    </chapps-primary-button>
  </section>
</chapps-tab-group>

<ng-template #LegacyMessageView>
  <div *ngIf="isLoading" class="flex-center m-4">
    <mdb-spinner spinnerColor="blue"></mdb-spinner>
  </div>
  <div *ngIf="isListEmpty() && !isLoading" class="alert alert-light m-4" role="alert">
    {{ Localization.EmptyDataMessage | translate }}
  </div>
  <table *ngIf="!isListEmpty() && !isLoading" mdbTable
         class="details-table table-with-actions table-no-first-border mb-0"
         [striped]="true" [hover]="true">
    <thead>
    <tr>
      <th [translate]="Localization.PlaceAndMessage"></th>
      <th [translate]="Localization.Reported"></th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr mdbTableCol *ngFor="let item of list" class="clickable" (click)="goToNotificationDetailsPage(item)">
      <td colspan="2">
        <app-message-list-item [model]="item" (clicked)="goToNotificationDetailsPage(item)"></app-message-list-item>
      </td>
      <td class="text-center align-middle move-right-animation">
        <i class="fas fa-angle-right fa-lg"></i>
      </td>
    </tr>
    </tbody>
  </table>
</ng-template>
